import React from 'react';
import {
	IconButton,
	Menu,
	MenuItem,
	TableCell,
	TableRow,
	Typography
} from '@mui/material';
import { MoreHoriz } from '@mui/icons-material';
import { useMenu } from 'hooks';

const CostItem = ({ costItem, handleClick }) => {
	const { open, anchorEl, handleToggleMenu, handleClose } = useMenu();

	const renderMenu = () => (
		<Menu open={open} onClose={handleClose} anchorEl={anchorEl}>
			<MenuItem onClick={(e) => handleEditClick(costItem, e)}>Edit</MenuItem>
		</Menu>
	);

	return (
		<TableRow
			hover
			onClick={() => handleClick(costItem)}
			sx={{ cursor: 'pointer' }}
		>
			<TableCell>
				<Typography variant="primary.text">{costItem.name}</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">{costItem.item}</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">{costItem.cost}</Typography>
			</TableCell>
			<TableCell align="right">
				<IconButton
					onClick={(e) => {
						e.stopPropagation();
						handleToggleMenu(e);
					}}
				>
					<MoreHoriz />
				</IconButton>
				{renderMenu()}
			</TableCell>
		</TableRow>
	);
};

export default CostItem;
